import { customElement, noShadowDOM } from 'solid-element'
import { createEffect, onCleanup } from 'solid-js'

export function install() {
  customElement(
    'ok-offer-button',
    { listingId: '', floating: false },
    (props, { element }) => {
      noShadowDOM()

      // Mount the button into the custom element
      createEffect(() => {
        // @ts-ignore
        const trigger = OfferKit.exec('mount', {
          listingId: props.listingId,
          container: !props.floating ? element : undefined,
        })

        onCleanup(async () => {
          ;(await trigger).unmount()
        })
      })

      return null
    }
  )
}
